module.exports = __webpack_public_path__ + "img/fl.8543893a.jpg";